export * from './src/search-platformized-v1-site-document-wix-site-search.meta.js';
